import type { PropsWithChildren } from 'react';
import React, { createContext, useContext, useMemo } from 'react';
import type { InitialState } from '../FeatureHubAppDefinition';

interface State {
  readonly initialState: InitialState;
}

export const Context = createContext<State>({} as State);

interface InitialStateContextProviderProps {
  readonly initialState: InitialState;
}

export const InitialStateContextProvider = ({
  children,
  initialState,
}: PropsWithChildren<InitialStateContextProviderProps>) => {
  return useMemo(
    () => (
      <Context.Provider
        value={{
          initialState,
        }}
      >
        {children}
      </Context.Provider>
    ),
    [initialState],
  );
};

export const useInitialState = () => useContext(Context).initialState;
